import React from 'react';
import { Col, Modal, Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import Loading from 'layouts/public/loading/Loading'

class AddNewPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            sponsorId: props.sponsorId
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            sponsorId: nextProps.sponsorId
        });
    }

    close = (success) => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose(success);
        });
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px", textAlign:"center" }}>
                        Add New Member
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                            :
                            <Row>
                                <Col md={6} style={{textAlign:"center"}}>
                                    <Button 
                                        id='btnManualAdd' 
                                        onClick={this.getBusy}
                                        bsClass="btn btn-app bg-green"
                                        href="/admin/sponsorSetup/new"
                                        style={{width:"150px", height:"100px"}}>
                                        <FontAwesomeIcon icon={faEdit} size="2x" style={{marginTop:"10px", marginBottom:"10px"}}/>
                                        <br />
                                        Manual Entry
                                    </Button>
                                </Col>
                                <Col md={6} style={{textAlign:"center"}}>
                                    <Button 
                                        id='btnPaypalAdd' 
                                        onClick={this.getBusy}
                                        bsClass="btn btn-app bg-blue"
                                        href="/admin/paypalInvoiceSetup"
                                        style={{width:"150px", height:"100px"}}>
                                        <FontAwesomeIcon icon={faExchangeAlt} size="2x" style={{marginTop:"10px", marginBottom:"10px"}}/>
                                        <br />
                                        PayPal Integration
                                    </Button>
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close} disabled={this.state.busy}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default AddNewPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/AddNewPopUp.js